import { LoadingButton } from '@mui/lab';
import { DialogActions, Button, Typography } from '@mui/material';
import { FormattedMessage } from 'react-intl';

export type CustomDialogActionsProps = {
    onClose: () => void;
    handleSubmit: () => void;
    selectedRows: any[];
    loadingSubmit: boolean;
};

export const CustomDialogActions = ({ onClose, handleSubmit, selectedRows, loadingSubmit }: CustomDialogActionsProps) => (
    <DialogActions
        sx={({ palette }) => ({ px: '24px', display: 'flex', justifyContent: 'flex-end', height: '64px', bgcolor: palette.primary[300] })}
    >
        <Button
            disabled={loadingSubmit}
            onClick={() => onClose()}
            sx={{ width: '80px', height: '32px', borderRadius: '8px' }}
            color="secondary"
            variant="outlined"
        >
            <Typography fontSize="14px" color="secondary">
                <FormattedMessage id="cancel" />
            </Typography>
        </Button>
        <LoadingButton
            onClick={handleSubmit}
            loading={loadingSubmit}
            sx={{ width: '102px', height: '32px', p: 0, borderRadius: '8px' }}
            color="secondary"
            variant="contained"
        >
            <Typography fontSize="14px">Import ({selectedRows.length || 'All'})</Typography>
        </LoadingButton>
    </DialogActions>
);
